import { CustomFeaturesModule } from '@app/custom/custom-features.module';
import { NgModule } from '@angular/core';

@NgModule({
  exports: [CustomFeaturesModule],
  imports: [CustomFeaturesModule],
})
export class CustomModule {}
